import { filter } from "lodash";
import PropTypes from "prop-types";
import React from "react";

import { PropTypeShapes } from "../../types";

const ModalRow = props => {
  let classNames = filter(
    [
      "modalRow",
      props.border ? "border" : null,
      props.header ? "header" : null,
      props.alignMiddle ? "alignMiddle" : null,
      props.alignRight ? "alignRight" : null,
      props.expandHeight ? "expandHeight" : null,
      props.minFieldWidth ? "minFieldWidth" : null,
      props.alignTop ? "alignTop" : null
    ],
    c => c
  );
  return <div className={classNames.join(" ")}>{props.children}</div>;
};

ModalRow.propTypes = {
  children: PropTypeShapes.elementOrArray,
  border: PropTypes.bool,
  header: PropTypes.bool,
  alignTop: PropTypes.bool,
  alignMiddle: PropTypes.bool,
  alignRight: PropTypes.bool,
  expandHeight: PropTypes.bool,
  minFieldWidth: PropTypes.bool
};

export default ModalRow;
